<div class="ui-g">

    <div class="el_height ui-lg-10 ui-md-8 ui-sm-12">
        <p-chips [(ngModel)]="filterAccounts" allowDuplicate=false field="name"
            (onRemove)="this.removeAccount($event.value)">
            <ng-template let-item pTemplate="item">
                <div pTooltip="{{item.desc}}" tooltipPosition="top" [escape]=false>
                    <span>{{item}}</span>
                </div>
            </ng-template>
        </p-chips>
    </div>
    <div class="ui-g-2 ui-lg-2 ui-md-4 ui-sm-12">
        <button type="button" pButton icon="ui-icon-touch-app" label="Pick" style="width: 100%;" (click)="openFilterPicker()"></button>
    </div>

    <p-dialog header="Report Filter" [(visible)]="displayFilter" *ngIf="displayFilter"
        [style]="{width: '90%', align: 'center' }" appendTo="body">
        <div class="ui-g">
            <div class="ui-g-12">
                <p *ngIf="!accountsForFilterExist">There are no accounts available for filter...</p>
                <p-treeTable *ngIf="accountsForFilterExist" #accountFilterTree id="filterTable" [scrollable]="true" scrollHeight="500px"
                    (onNodeExpand)="onTreeOfAccountsExpand($event)" [totalRecords]="totalTreeOfAccountsNumber"
                    [rows]="10" [contextMenu]="accountFilterTreeContextMenu" [value]="accountsForFilter" [columns]="tableColumns"
                    selectionMode="multiple" [(selection)]="selectedAccountFilter" dataKey="id" [virtualScroll]="true"
                    [virtualRowHeight]="15">
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <!-- <col *ngFor="let col of tableColumns" [style.width]="col.width"> -->
                            <col>
                        </colgroup>
                    </ng-template>
                    <ng-template pTemplate="caption">
                        <input type="text" pInputText placeholder="Search..."
                            (input)="accountFilterTree.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                        <tr [ttSelectableRow]="rowNode" [ttContextMenuRow]="rowNode">
                            <!-- <td *ngFor="let col of tableColumns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0">
                                </p-treeTableToggler>
                                {{rowData[col.field]}}
                            </td> -->
                            <td>
                                <p-treeTableToggler [rowNode]="rowNode">
                                </p-treeTableToggler>
                                {{rowData.code}} {{rowData.name}}
                            </td>
                        </tr>
                    </ng-template>
                </p-treeTable>
                <p-contextMenu #accountFilterTreeContextMenu [model]="contextMenuItems" appendTo="body"></p-contextMenu>
            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-12">
                <button type="button" label="OK" pButton icon="ui-icon-check" (click)="addNewAccountToFilter()"
                    style="margin-right: 0.5em;"></button>
                <button type="button" label="Cancel" pButton icon="ui-icon-cancel"
                    (click)="displayFilter=false"></button>
            </div>
        </div>
    </p-dialog>
</div>